import { render, staticRenderFns } from "./NotifyForm.vue?vue&type=template&id=49431fa1"
import script from "./NotifyForm.vue?vue&type=script&lang=js"
export * from "./NotifyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49431fa1')) {
      api.createRecord('49431fa1', component.options)
    } else {
      api.reload('49431fa1', component.options)
    }
    module.hot.accept("./NotifyForm.vue?vue&type=template&id=49431fa1", function () {
      api.rerender('49431fa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/notify/NotifyForm.vue"
export default component.exports